// Folder cards are both drag sources (move a branch into another folder) and drop targets (drop an
// item or another folder in). dnd-kit keeps draggables and droppables in separate registries, so the
// two ids are namespaced apart here to keep `onDragEnd` unambiguous about what was dropped where.
const DRAG_PREFIX = 'folder-drag-'
const DROP_PREFIX = 'folder-'

// The drop target that means "out of every folder" — the "All Items" breadcrumb.
export const ROOT_DROP_ID = 'folder-root'

export const folderDragId = (folderId) => `${DRAG_PREFIX}${folderId}`

export const folderDropId = (folderId) => `${DROP_PREFIX}${folderId}`

// The folder a drop id names, or null for the root target and for anything that isn't a folder.
export const parseFolderDropId = (dropId) => {
  const id = String(dropId)
  if (id === ROOT_DROP_ID || !id.startsWith(DROP_PREFIX)) return null
  return id.slice(DROP_PREFIX.length)
}

export const isFolderDropId = (dropId) => String(dropId).startsWith(DROP_PREFIX)
